import clsx from 'clsx';
import { useEffect } from 'react';
import {
  type SegmentAttributes,
  useSegmentInteraction,
} from '../../../../../lib/analytics/useSegmentInteraction';
import { Button } from '../../../../Button';
import { useAuthUrlsContext } from '../../AuthUrlsProvider';

export function SignupButton() {
  const { signUpUrl } = useAuthUrlsContext();

  const segmentAttributes: SegmentAttributes = {
    entity_name: 'register_button',
    section_name: 'global_nav_reg_cta_v1',
    registration_cohort: 'new_insights',
  };

  const fireButtonVisibleEvent = useSegmentInteraction({
    eventName: 'Element Impression',
    attributes: segmentAttributes,
  });

  const fireButtonClickedEvent = useSegmentInteraction({
    eventName: 'Element Interaction',
    attributes: segmentAttributes,
  });

  useEffect(() => {
    fireButtonVisibleEvent();
  }, []);

  return (
    <Button
      variant="primary"
      component="a"
      href={signUpUrl}
      className={clsx('hidden', 'sm:inline-block')}
      onClick={fireButtonClickedEvent}
    >
      Sign up
    </Button>
  );
}
